import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/svg/placeholder-image.svg?data'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Default avatar"
}, null, -1)
const _hoisted_2 = { class: "h5" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Drop your image here or ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Supports .jpeg, .png. Max upload size 20mb.", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Save ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppAlert = _resolveComponent("AppAlert")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"])),
    class: "profile-picture-upload",
    ref: "form"
  }, [
    _withDirectives(_createElementVNode("input", {
      ref: "inputFile",
      type: "file",
      name: "file-upload",
      id: "file-upload",
      accept: "image/png,image/jpeg",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleDrop($event, true)))
    }, null, 544), [
      [_vShow, false]
    ]),
    _createVNode(_component_Modal, {
      id: _ctx.id,
      title: _ctx.title
    }, {
      default: _withCtx(() => [
        (Object.keys(_ctx.fileUploadErrors).length > 0)
          ? (_openBlock(), _createBlock(_component_AppAlert, {
              key: 0,
              theme: "danger",
              icon: "error",
              style: {"margin-bottom":"32px"}
            }, {
              default: _withCtx(() => [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileUploadErrors, (error) => {
                    return (_openBlock(), _createElementBlock("li", { key: error }, _toDisplayString(error), 1))
                  }), 128))
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
          onDragenter: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
          onDrop: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", {
            class: "profile-picture-upload__drop",
            onDrop: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDrop($event, false)))
          }, [
            _hoisted_1,
            _createElementVNode("p", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.inputFile.click && _ctx.inputFile.click(...args)), ["prevent"]))
              }, "browse")
            ]),
            _hoisted_4
          ], 32)
        ], 32)
      ]),
      actions: _withCtx(() => [
        _createVNode(_component_AppButton, {
          theme: "secondary",
          onClick: _ctx.cancelUpload
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_AppButton, { disabled: "" }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["id", "title"])
  ], 544))
}